/**
 * @type {string}
 */
export const API_AGENCY_APPLICATION_NAME = 'company_name_tenancy_application';

/**
 * @type {string}
 */
export const API_AGENCY_LOGO = 'logo';
